import { LOGGED_OUT_PARAM } from 'client/utils/routes/routeConstants';
import { LogLevel } from '@azure/msal-browser';
import { webClientId, apiClientId, signInUserFlow, portalBaseUrl } from 'client/utils/constants/frontEndConfig';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: signInUserFlow,
        forgotPassword: signInUserFlow
    },
    authorities: {
        signUpSignIn: {
            authority: `https://nuarb2c.b2clogin.com/nuarb2c.onmicrosoft.com/${signInUserFlow}`
        },
        forgotPassword: {
            authority: `https://nuarb2c.b2clogin.com/nuarb2c.onmicrosoft.com/${signInUserFlow}`
        }
    },
    authorityDomain: 'nuarb2c.b2clogin.com'
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: webClientId, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: portalBaseUrl,
        postLogoutRedirectUri: `${portalBaseUrl}#${LOGGED_OUT_PARAM}`, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                if (level === LogLevel.Error) {
                    // eslint-disable-next-line no-console
                    console.error(message);
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const scopes = [
    'openid',
    'offline_access',
    `https://nuarb2c.onmicrosoft.com/${apiClientId}/api`
];

/**
 * Negates SSO.
 * For more information about prompts, visit:
 * https://learn.microsoft.com/en-us/azure/active-directory/develop/msal-js-prompt-behavior
 */
export const prompt = 'login';
